import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export const LoadingButton = ({
  loading,
  children,
  className,
  disabled,
  ...props
}) => {
  return (
    <Button className={cn(className)} disabled={loading || disabled} {...props}>
      {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
      {children}
    </Button>
  );
};
